import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

export const fetchBackgroundbanners = createAsyncThunk(
  "backgroundbanner/fetchBackgroundbanners",
  async () => {
    const response = await axios.get(apiurl + "viewproductorcategory");
    return response.data.data; // Assuming the banner data is in `data`
  }
);

const initialState = {
  backgroundbanner: [],
  loading: false,
  status: "idle",
  error: null,
};

const BackgroundbannerSlice = createSlice({
  name: "backgroundbanner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBackgroundbanners.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchBackgroundbanners.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.backgroundbanner = action.payload;
      })
      .addCase(fetchBackgroundbanners.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default BackgroundbannerSlice.reducer;
